//src/components/notification/NotificationPortalView.tsx
import React from "react";
import { useLayout } from "../layout/LayoutContext";
import Layout from "../layout/Layout";
import PortalRoot from "../portal/PortalRoot";
import { OverlayOpacity } from "../portal/types";
import NotificationListView from "./NotificationListView";
import { useUser } from "../../contexts/UserContext";
import { Notification } from "../../gql/types";
import styles from "./NotificationPortalView.module.css";

interface NotificationPortalViewProps {
    onCloseNotificationPortalView: () => void;
    onClickNotification?: (notification: Notification) => void;
}

const NotificationPortalView: React.FC<NotificationPortalViewProps> = ({
    onCloseNotificationPortalView,
    onClickNotification,
}) => {
    const { baseZIndex } = useLayout();
    const { user } = useUser();


    if (user === null) {
        return <></>;
    }

    //TODO: Handle onClickNotification properly (overlay/popup)

    return (
        <PortalRoot
            baseZIndex={baseZIndex}
            overlayOpacity={OverlayOpacity.COVERED}
        >
            <Layout
                colorMode = "gray"
                navbarConfig={{
                    title: "Notifications",
                    showLogo: false,
                    hamburgerMenu: false,
                    onBack: onCloseNotificationPortalView,
                }}
                baseZIndex={baseZIndex ? baseZIndex + 1 : 1}
            >
                <div className={styles.notificationPortalViewContainer}>
                    <NotificationListView
                        user={user}
                        onClickNotification={onClickNotification}
                    />
                </div>

            </Layout> 
        </PortalRoot>
    );
};

export default NotificationPortalView;

